import React, { useState, useEffect } from "react";
// React Bootstrap
import { Navbar, Form, FormControl, InputGroup } from "react-bootstrap";
// Componentes
import MisionTarjeta from "./MisionTarjeta";
import GenericExplorer from "../../generic/GenericExplorer";
import MisionTarjetaAdd from "./MisionTarjetaAdd";
// Styled Components
import styled from "styled-components";
// Contexto
import { tiposObras, tiposProyectos, tiposEnColaboracion, tipoMisiones } from "../../../contexto";
import TooltipIcon from "../../generic/TooltipIcon";

const CustomNavBar = styled(Navbar)`
  min-width: 200px;
`;

const Misiones = ({ userLevel, ...props }) => {
  // TODO quitar coger los parametro asi ponerlo en el root
  const idProvincia = props.computedMatch.params.id_p;

  // Filtros
  const [search, setSearch] = useState("");
  // Tipo de la mision
  const [missionTypeList, setMissionTypeList] = useState({ "": "Todos", ...tipoMisiones });
  const [missionType, setMissionType] = useState("Todos");
  // Categoria de la mision
  const [categoryList, setCategoryList] = useState({ "": "Todos", ...tiposProyectos, ...tiposObras, ...tiposEnColaboracion });
  const [missionCategory, setMissionCategory] = useState("Todos");
  // Categoria
  const [missionCollaborative, setMissionCollaborative] = useState(false);
  const [todaMision, setTodaMision] = useState(false);

  useEffect(() => {
    if (missionType === "Proyecto") {
      setCategoryList({ "": "Todos", ...tiposProyectos });
    }
    if (missionType === "Obra") {
      missionCollaborative ? setCategoryList({ "": "Todos", ...tiposObras, ...tiposEnColaboracion }) : setCategoryList({ "": "Todos", ...tiposObras });
    }
    if (!missionType) {
      setCategoryList({ "": "Todos", ...tiposProyectos, ...tiposObras, ...tiposEnColaboracion });
    }
  }, [missionType, missionCollaborative]);

  // A partir de los valores de los filtros obtiene el query string
  const getQueryString = () => {
    return (
      "?count=20" +
      (search ? "&findName=" + search : "") +
      (missionType && missionType !== "Todos" ? "&type=" + missionType : "") +
      (missionCategory && missionCategory !== "Todos" ? "&category=" + missionCategory : "") +
      (missionCollaborative ? "&collaborative=" + missionCollaborative : "") +
      (todaMision ? "&todaMision=true" : "")
    );
  };

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleChangeMissionType = (e) => {
    setMissionCategory("");
    setMissionType(e.target.value);
  };

  const handleChangeMissionCategory = (e) => {
    setMissionCategory(e.target.value);
  };

  return (
    <>
      <GenericExplorer url={"/provincias/" + idProvincia + "/misiones" + getQueryString()} 
      ItemCard={MisionTarjeta} 
      ItemAddCard={userLevel >=10 ? MisionTarjetaAdd : null}
      userLevel={userLevel}
      >
        <h2>Misión</h2>
        <CustomNavBar expand="md">
          <Navbar.Toggle aria-controls="Assets filter" className="bg-light mb-3">
            <span className="align-text-bottom"> {"Filtros"}</span>
          </Navbar.Toggle>
          <Navbar.Collapse className="mb-3" id="basic-navbar-nav">
            <Form as="div" inline className="w-100">
              <FormControl onChange={handleChangeSearch} type="text" placeholder={"Búsqueda"} className="mr-3" />
              <InputGroup className="mr-3">
                <InputGroup.Prepend>
                  <InputGroup.Text>{"Tipo misión"}</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control as="select" custom onChange={handleChangeMissionType} value={missionType}>
                  {Object.keys(missionTypeList).length &&
                    Object.keys(missionTypeList).map((typeKey) => (
                      <option key={typeKey} value={typeKey}>
                        {missionTypeList[typeKey]}{!missionCollaborative && " STJ"}
                      </option>
                    ))}
                </Form.Control>
              </InputGroup>
              <InputGroup className="mr-3">
                <InputGroup.Prepend>
                  <InputGroup.Text>{"Categoría misión"}</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control as="select" custom onChange={handleChangeMissionCategory} value={missionCategory}>
                  {Object.keys(categoryList).length &&
                    Object.keys(categoryList).map((categoryKey) => (
                      
                      <option key={categoryKey} value={categoryKey}>
                        {categoryList[categoryKey]}
                      </option>
                    ))}
                </Form.Control>
              </InputGroup>
              <InputGroup className="mt-2">
                <Form.Group>
                  <Form.Check type="checkbox" label="Misión en colaboración" value={missionCollaborative} onClick={() => setMissionCollaborative(!missionCollaborative)} />
                  <TooltipIcon className={"ml-1 pb-1 mr-3"} content={`Al seleccionar esta opción se filtra la misión en colaboración`} />
                </Form.Group>
              </InputGroup>
              <InputGroup className="mt-2">
                <Form.Group>
                  <Form.Check type="checkbox" label="Toda la misión" value={todaMision} onClick={() => setTodaMision(!todaMision)} />
                  <TooltipIcon className={"ml-1 pb-1"} content={`Al seleccionar esta opción se muestra toda la misión incluída la cesada actualmente`} />
                </Form.Group>
              </InputGroup>
            </Form>
          </Navbar.Collapse>
        </CustomNavBar>
      </GenericExplorer>
    </>
  );
};

export default Misiones;
